import home from './home'
import teacher from './teacher'
import dynamic from './dynamic'
import about from './about'
import audio from './audio'
import result from './result'
import center from './center'

export default {
  home,
  teacher,
  dynamic,
  about,
  audio,
  result,
  center,
}



// WEBPACK FOOTER //
// ./src/api/index.js